<template>
  <div class="rooming">
    <p class="p">
      En este paso completa los datos de cada pasajero. Si tenés un cupón de descuento, podes
      utilizarlo debajo (no olvides apretar en "Verificar" para aplicar tu descuento). Una vez
      tengas todos tus pasajeros asignados y podras ver el subtotal de la reserva, y
      confirmarla.
    </p>
    <div class="rooming-main">
      <div class="rooming-col-right">
        <div>
          <div class="discount">
            <input-btn
              v-if="!budget.promo_code && budget.id"
              :placeholder="'Ingresa Cupon de descuento'"
              @submit="quote"
            >
              VERIFICAR
            </input-btn>
            <p
              class="discount--msg"
              v-else
            >
              <span>{{ budget.promotion_description }}</span>
            </p>
          </div>
          <div>
            <div
              v-for="passenger in $store.state.booking.passengers"
              :key="passenger.tmp_id"
            >
              <template v-if="!editable || editable.tmp_id == passenger.tmp_id">
                <passenger
                  :passenger="passenger"
                  @sit="assign"
                  @locate="locate"
                  :editable="editable"
                />
              </template>
            </div>
          </div>
        </div>
        <worth :budget="budget" />
      </div>
      <div class="rooming-col-left">
        <p
          class="rooming-timer"
          v-if="this.$store.state.booking.session < 901"
        >
          Asientos bloqueados
          <strong>{{ timer.minutes }}:{{ timer.seconds }}</strong>
        </p>
        <locations
          :bus="bus"
          :seats="$store.state.booking.seats"
          :hotels="hotels"
          ref="locations"
          @notes="
            value =>
              (notes = notes
                .filter(n => n.hotel_id != value.hotel_id)
                .concat([value]))
          "
        />
      </div>
    </div>
    <div class="txt-right py-2 border-top my-3">
      <btn
        color="white"
        size="xs"
        @click="$emit('close')"
      >
        CANCELAR
      </btn>
      <btn
        color="orange"
        size="xs"
        v-if="budget.id"
        @click="next"
      >
        CONFIRMAR
      </btn>
    </div>
  </div>
</template>
<script>
import Btn from '@/components/Btn'
import Passenger from './components/Passenger'
import InputBtn from '@/components/InputBtn'
import Worth from './components/Worth'
import Locations from './components/Locations'
import swal from 'sweetalert2'
import { PASSENGERS, ROOMING, CODE } from '@/store/mutations'
import { clone, padding0 } from '@/utils'

const info = title => swal({ type: 'info', title })
const NS = 'booking/'
let subscribe = () => 1

export default {
  components: {
    Worth,
    Btn,
    Passenger,
    Locations,
    InputBtn
  },

  props: ['departure'],

  mounted () {
    subscribe = this.$store.subscribe(mutation => {
      if (mutation.type == NS + PASSENGERS) {
        this.$store.dispatch(`${NS}BUDGETING`)
      }
    })
  },

  beforeDestroy () {
    subscribe()
  },

  computed: {
    timer () {
      return {
        seconds: padding0(Math.floor(this.$store.state.booking.session % 60), 2),
        minutes: padding0(Math.floor((this.$store.state.booking.session / 60) % 60), 2)
      }
    },
    passengers () {
      return clone(this.$store.state.booking.passengers)
    },
    hotels () {
      return []
    },
    bus () {
      return []
    },
    budget () {
      return this.$store.state.booking.budget
    }
  },

  methods: {
    distribute (rooming, passenger_tmp_id) {
      this.$store.commit(
        NS + PASSENGERS,
        clone(this.$store.state.booking.passengers).map(passenger => {
          if (passenger.tmp_id == passenger_tmp_id) {
            passenger.rooming = {
              tmp_id: rooming.tmp_id,
              base: rooming.base,
              rooms: rooming.rooms
            }
          }
          return passenger
        })
      )
      this.$store.commit(
        NS + ROOMING,
        clone(this.$store.state.booking.rooming).map(room => {
          if (room.tmp_id == rooming.tmp_id) {
            room.passengers = room.passengers.concat([passenger_tmp_id])
          }
          return room
        })
      )
      this.$refs.locations.disable = null
      this.$refs.locations.hover = null
      this.editable = null
    },
    sit (seat, tmp_id) {
      const passengers = this.$store.state.booking.passengers
      if (passengers.some(p => p.seat_id == seat.id)) {
        info('El asiento ya esta ocupado.')
        this.assign(tmp_id)
      } else {
        this.$store.commit(
          NS + PASSENGERS,
          passengers.map(passenger => {
            if (passenger.tmp_id == tmp_id) {
              passenger.seat_id = seat.id
              passenger.seat_categ = seat.categ
              passenger.seat_categ_str = seat.categ_str
            }
            return passenger
          })
        )
        this.$refs.locations.disable = null
        this.$refs.locations.hover = null
        this.editable = null
      }
    },
    locate (tmp_id) {
      this.$refs.locations.$once('distribute', room => this.distribute(room, tmp_id))
      this.$refs.locations.disable = 'buses'
      this.$refs.locations.hover = 'hotels'
      this.editable = { tmp_id, action: 'hotels' }
    },
    assign (tmp_id) {
      this.$refs.locations.$once('sit', seat => this.sit(seat, tmp_id))
      this.$refs.locations.disable = 'hotels'
      this.$refs.locations.hover = 'buses'
      this.editable = { tmp_id, action: 'buses' }
    },
    quote (code) {
      this.$store.commit(NS + CODE, code)
      this.$store.dispatch(`${NS}BUDGETING`)
    },
    next () {
      if (this.passengers.find(p => p.main && p.ident && p.name && p.surname)) {
        this.$store.dispatch(`${NS}ROOMING`, this.notes || '')
      } else {
        info(
          'Debe completar al menos DNI/PASAPORTE, APELLIDO Y NOMBRE del pasajero titular.'
        )
      }
    }
  },
  data () {
    return {
      editable: null,
      rate: this.$store.state.booking.rate,
      notes: []
    }
  }
}
</script>
